import { FormattedMessage } from 'react-intl';
import cx from 'clsx';
import type { ReactNode } from 'react';
import { Button } from '@repo/design-system-kit/components/button/button';
import { QrCode } from '@repo/design-system-kit/components/qr-code/qr-code';
import { BackButtonSimple } from '../../shared/back-button-simple';
import styles from './download-app.module.css';

export function DownloadApp({
  qrCodeUrl,
  token,
  onBack,
  onSendSms,
}: {
  token: string;
  onBack: () => void;
  onSendSms: () => void;
  qrCodeUrl?: string;
}): ReactNode {
  return (
    <div className={styles.container}>
      <div className={cx('mb-48', styles.content)}>
        <h1 className="heading-section mb-16">
          <FormattedMessage
            defaultMessage="Grab your phone for your identification"
            id="identity-verification-kit.qonto-idnow.desktop.switch-to-mobile.title"
          />
        </h1>
        <p className="body-standard mb-32">
          <FormattedMessage
            defaultMessage="Follow the instructions below to perform your identification on your phone. Once done, this page will reload automatically, allowing you to continue your account opening."
            id="identity-verification-kit.qonto-idnow.desktop.switch-to-mobile.subtitle"
          />
        </p>
        <h2 className="body-prominent mb-16">
          <FormattedMessage
            defaultMessage="1. Download the IDnow Online Ident app"
            id="identity-verification-kit.qonto-idnow.desktop.switch-to-mobile.list-item1"
          />
        </h2>
        <p className="body-standard mb-16">
          <FormattedMessage
            defaultMessage="You can scan the QR code or send an SMS with a download link to your phone."
            id="identity-verification-kit.qonto-idnow.desktop.switch-to-mobile.list-item1-subtitle"
          />
        </p>

        <div className={cx('mb-32', styles.insetBoxLink, styles.insetBox)}>
          <QrCode className={styles.qrCode} fallbackSrc="" url={qrCodeUrl} />
          <div className={styles.separator}>
            <div className={styles.separationBar} />
            <FormattedMessage
              defaultMessage="or"
              id="identity-verification-kit.qonto-idnow.desktop.switch-to-mobile.separator"
            />
            <div className={styles.separationBar} />
          </div>
          <Button data-test-send-sms onPress={onSendSms} type="button" variant="secondary">
            <FormattedMessage
              defaultMessage="Send a link via SMS"
              id="identity-verification-kit.qonto-idnow.desktop.switch-to-mobile.list-item1-sms-cta"
            />
          </Button>
        </div>

        <h2 className="body-prominent mb-24">
          <FormattedMessage
            defaultMessage="2. Open the app and enter the following identification code (Ident-ID)"
            id="identity-verification-kit.qonto-idnow.desktop.switch-to-mobile.list-item2"
          />
        </h2>
        <div className={cx(styles.insetBox, styles.insetBoxCode)}>{token}</div>
      </div>

      <BackButtonSimple data-test-back onPress={onBack} />
    </div>
  );
}
